// WhyStudents.js
import React from "react";
import { motion } from "framer-motion";
import "./WhyStudents.css";
import studentImg from "../Assets/student.png";
import patternDots from "../Assets/Triangle.png";

const WhyStudents = () => {
  return (
    <section className="why-section">
      {/* pattern layer */}
      <div
        className="why-pattern pattern-img"
        style={{ backgroundImage: `url(${patternDots})` }}
        aria-hidden="true"
      />

      <div className="why-container">
        {/* Image with fade + slide from left */}
        <motion.div
          className="why-image"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <img src={studentImg} alt="Student" />
        </motion.div>

        {/* Content with fade + slide from right */}
        <motion.div
          className="why-content"
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2>
           At NewZeal, Spoken English Isn’t Just a Course – It’s Your Key <span>to Success in Career and to enhance Social Respect</span>
          </h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            viewport={{ once: true }}
          >
         At NewZeal Language Academy, our Spoken English course is carefully designed to give you the skills that truly matter in daily life. Whether you’re a <b>student</b> preparing for exams, group discussions, or interviews; a <b>professional</b> aiming to present ideas, attend meetings, and grow in your career; or an <b>entrepreneur</b> looking to build networks, handle clients, and expand your business — we prepare you to express yourself with clarity and confidence.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.6 }}
            viewport={{ once: true }}
          >
            And for <b>homemakers</b>, our lessons make it easier to support your children with homework, participate in parent-teacher meetings, and interact confidently in social gatherings.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.6 }}
            viewport={{ once: true }}
          >
           More than just grammar and vocabulary, our focus is on practical communication that helps you connect with people, create lasting impressions, and earn respect in society. With step-by-step guidance, real-life practice sessions, and a supportive environment, we help you grow from hesitation to fluency — making English your strength in both personal and professional life.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyStudents;
